import React from 'react'

import Base from '../_Base'

const Manga = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="m20 17.198-7 1.556V6.802l7-1.555v11.95zM4 5.247l7 1.555v11.952l-7-1.556V5.247zM21.625 3.22a1.003 1.003 0 0 0-.842-.196L12 4.976 3.217 3.024A1 1 0 0 0 2 4v14a1 1 0 0 0 .783.976l9 2a.988.988 0 0 0 .434 0l9-2A1 1 0 0 0 22 18V4a1 1 0 0 0-.375-.78z"
      fillRule="evenodd"
    />
  </Base>
)

export default Manga
